import { UserDto } from '~modules/user/model';

export function getName(user: UserDto): string {
	let name = user.name ?? `${user.given_name} ${user.family_name}`.trim();
	if (name.length <= 0) name = user.preferred_username;
	return name;
}
